import { Component, OnInit, Input } from '@angular/core';
import { RangeDto } from '../../models/range.dto';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'app-range-picker',
  templateUrl: './range-picker.component.html',
  styleUrls: ['./range-picker.component.scss'],
})
export class RangePickerComponent implements OnInit {
  @Input() form: UntypedFormControl;
  range = new RangeDto();
  constructor() {}

  ngOnInit(): void {}

  valueChanged() {
    this.form.setValue(this.range.toTimeSpan());
  }
}
